export const isValidPrompt = (prompt: string) => {
	// Checks if the prompt is at least 3 words long
	return (
		prompt
			.trim()
			.split(' ')
			.filter((word) => word.length > 0).length >= 3
	);
};

export const truncatePrompt = (prompt: string, maxLength = 50) => {
	if (prompt.length <= maxLength) {
		return prompt;
	}
	return prompt.substring(0, maxLength).trim() + '…';
};
